import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon, ClockIcon, StarIcon, TrophyIcon } from 'lucide-react';
import { CHECKOUT_URL, PRICE_FULL, PRICE_SHORT, Section, trackCheckoutClick } from './Shared';
import { DnaHelix, Mandala } from './BioDecor';
function LaunchUrgency() {
  const [timeLeft, setTimeLeft] = useState({
    h: 0,
    m: 53,
    s: 58
  });
  const spotsTaken = 75;
  useEffect(() => {
    const timer = window.setInterval(() => setTimeLeft(current => {
      const seconds = Math.max(0, current.h * 3600 + current.m * 60 + current.s - 1);
      return {
        h: Math.floor(seconds / 3600),
        m: Math.floor(seconds % 3600 / 60),
        s: seconds % 60
      };
    }), 1000);
    return () => window.clearInterval(timer);
  }, []);
  const format = (value: number) => value.toString().padStart(2, '0');
  const TimeBox = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-164" data-mp="12qzpvczkc0ac">
      <div className="min-w-[58px] rounded-xl bg-brand-blue px-3 py-2 font-mono text-2xl font-bold tabular-nums text-brand-goldLight ring-1 ring-brand-gold/40 md:min-w-[80px] md:px-5 md:py-3 md:text-4xl" data-id="element-165" data-mp="12rrcvzf3gpp0">
        {format(value)}
      </div>
      <span className="mt-1.5 text-[10px] font-semibold uppercase tracking-wider text-brand-muted md:text-sm" data-id="element-166" data-mp="17q2jm1a3ek30">
        {label}
      </span>
    </div>;
  return <div className="mx-auto mb-12 max-w-4xl" data-id="element-167" data-mp="1mhl70k5a7gwe">
      <div className="paper-panel rounded-3xl border-2 border-brand-gold/40 p-6 md:p-8" data-id="element-168" data-mp="1hh6w8ucapsuo">
        <div className="mb-5 flex items-center justify-center gap-2" data-id="element-169" data-mp="1vgor9rg6q2ch">
          <ClockIcon className="h-5 w-5 text-brand-goldDark" data-id="element-170" data-mp="1vdsqlvcyczkc" />
          <h3 className="font-serif text-base font-bold text-brand-blue md:text-xl" data-id="element-171" data-mp="1qhlm8707fw4i">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </h3>
        </div>
        <div className="mb-5 flex items-center justify-center gap-2 md:gap-4" data-id="element-172" data-mp="3s8ynmm2yrlvt">
          <TimeBox value={timeLeft.h} label="Horas" data-id="element-173" data-mp="1w5ahrzpewzci" />
          <span className="pb-5 text-3xl font-bold text-brand-gold" data-id="element-174" data-mp="1w6varkw2wa89">:</span>
          <TimeBox value={timeLeft.m} label="Min" data-id="element-175" data-mp="213lsecnj7dvs" />
          <span className="pb-5 text-3xl font-bold text-brand-gold" data-id="element-176" data-mp="21688x1seh3q5">:</span>
          <TimeBox value={timeLeft.s} label="Seg" data-id="element-177" data-mp="261x28ndttoe0" />
        </div>
        <div className="mb-6 flex items-center justify-center gap-2 rounded-xl border border-brand-gold/50 bg-brand-goldLight/40 px-4 py-3" data-id="element-178" data-mp="2a5bqu2ftzd32">
          <AlertTriangleIcon className="h-5 w-5 shrink-0 text-brand-goldDark" data-id="element-179" data-mp="2f3wj9foucsgy" />
          <p className="text-center text-sm font-semibold text-brand-text md:text-base" data-id="element-180" data-mp="2k1y8yjgrvq1e">
            Después sube. <span className="text-brand-greenMid" data-id="element-181" data-mp="2ouhqfrikz5bh">No vuelve.</span>
          </p>
        </div>
        <div className="rounded-2xl border border-brand-blue/15 bg-white p-4 md:p-5" data-id="element-182" data-mp="2trrdj0ihz4w5">
          <div className="mb-3 flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between" data-id="element-183" data-mp="2xvp9j2cizzkz">
            <span className="flex items-center gap-2 text-sm font-semibold text-brand-text md:text-base" data-id="element-184" data-mp="32usg4r85mdv2">
              <span className="relative flex h-2.5 w-2.5" data-id="element-185" data-mp="r76s9tb1xuj7">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-brand-amber opacity-75" data-id="element-186" data-mp="m7kffkz4ygax" />
                <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-brand-amber" data-id="element-187" data-mp="i6qsattip5j3" />
              </span>
              Cupos al precio de lanzamiento
            </span>
            <span className="text-xs font-bold uppercase tracking-wide text-brand-goldDark" data-id="element-188" data-mp="19xeri0bms0u4">Quedan pocos</span>
          </div>
          <div className="mb-2 h-2.5 w-full overflow-hidden rounded-full bg-brand-blue/10" data-id="element-189" data-mp="15wctfmtg9utq">
            <div className="h-full rounded-full bg-brand-greenMid" style={{
            width: `${spotsTaken}%`
          }} data-id="element-190" data-mp="113jmcsaieaeh" />
          </div>
          <p className="text-center text-xs text-brand-muted md:text-sm" data-id="element-191" data-mp="w4yw9loz173r">
            <strong className="text-brand-greenMid" data-id="element-192" data-mp="1tl4frxkcziyl">{spotsTaken}%</strong> de los cupos al precio de lanzamiento ya
            tomados
          </p>
        </div>
      </div>
    </div>;
}
function Pricing() {
  return <Section id="comprar" glow className="my-12 rounded-3xl border border-brand-gold/45 bg-brand-parchment" data-id="element-193" data-mp="18d3f9awdqfyb">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 -z-10 overflow-hidden rounded-3xl" data-id="element-194" data-mp="1df154nzac908">
        <Mandala className="absolute left-6 top-8 h-20 w-20 text-brand-blueMist" data-id="element-195" data-mp="zg1e59oavi0w" />
        <DnaHelix className="absolute bottom-6 right-8 hidden h-40 w-20 text-brand-greenSoft/25 md:block" data-id="element-196" data-mp="14dbg1osvlm5m" />
      </div>

      <div className="relative mb-10 text-center" data-id="element-197" data-mp="1s501cl7a5ad2">
        <span className="animate-glow-pulse mb-4 inline-flex items-center gap-2 rounded-full bg-brand-blue px-4 py-1.5 text-[11px] font-bold uppercase tracking-wider text-brand-goldLight md:text-sm" data-id="element-198" data-mp="1w364zkctn9tr">
          🧬 Oferta de lanzamiento
        </span>
        <h2 className="font-display text-3xl font-bold text-brand-blue md:text-4xl" data-id="element-199" data-mp="1n9kqm24kjukv">
          TU <span className="text-brand-goldDark" data-id="element-200" data-mp="2azf2agd5jd3j">KIT MAESTRO DE BIODESCODIFICACIÓN</span>
        </h2>
        <p className="mt-3 text-sm font-semibold text-brand-greenMid md:text-base" data-id="element-201" data-mp="2fub2w4wgf8s9">
          Cierra pronto. Después sube. No vuelve.
        </p>
      </div>

      <div className="mx-auto max-w-2xl space-y-5" data-id="element-202" data-mp="2l4dnqwz6okrx">
        <div className="relative rounded-3xl" data-id="element-203" data-mp="2ywtsc27qgquy">
          <span className="glow-frame" aria-hidden="true" data-id="element-204" data-mp="2yvicv54xduo0" />
          <div className="relative z-10 rounded-3xl bg-white p-6 shadow-lg md:p-8" data-id="element-205" data-mp="2ty0da5cssrso">
            <div className="mb-3 flex items-center gap-1.5 text-brand-goldDark" data-id="element-206" data-mp="2u033apdyakxe">
              <TrophyIcon className="h-4 w-4 fill-current" data-id="element-207" data-mp="26a8po5lt4sc3" />
              <StarIcon className="h-4 w-4 fill-current" data-id="element-208" data-mp="227m6et37cfqi" />
              <span className="text-[10px] font-bold uppercase tracking-wider md:text-sm" data-id="element-209" data-mp="2g6c1y4adi7cr">
                El kit argentino más completo
              </span>
            </div>
            <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-210" data-mp="2b5xvursc17hd">
              <div className="max-w-md" data-id="element-211" data-mp="3rk7fj8lmq81v">
                <h3 className="font-serif text-lg font-bold text-brand-blue md:text-xl" data-id="element-212" data-mp="3mmecupjjbw6c">
                  🏆 KIT MAESTRO DE BIODESCODIFICACIÓN™
                </h3>
                <p className="mt-1 text-sm text-brand-muted" data-id="element-213" data-mp="3umkaf539dbhv">3 Tomos + 5 Bonus · Más de 150 páginas</p>
                <p className="mt-2 text-sm font-medium leading-relaxed text-brand-greenMid" data-id="element-214" data-mp="2hhufgtegx1f">
                  El sistema integral de protocolos, prácticas de integración, marco legal y seguimiento
                  post-sesión.
                </p>
              </div>
              <div className="shrink-0 text-right" data-id="element-215" data-mp="3b05vdn6qvtbw">
                <p className="text-xs uppercase tracking-wide text-brand-muted" data-id="element-216" data-mp="3ax9ym26mvap1">Valor original</p>
                <p className="text-lg text-brand-muted line-through" data-id="element-217" data-mp="3fvuy1ze29qcf">{PRICE_FULL}</p>
                <p className="mt-1 text-xs uppercase tracking-wide text-brand-muted" data-id="element-218" data-mp="3kvzddm38gf12">Precio de lanzamiento</p>
                <p className="font-serif text-4xl font-bold text-brand-greenMid md:text-5xl" data-id="element-219" data-mp="3pptxgqmr2w0o">{PRICE_SHORT}</p>
                <p className="text-xs text-brand-muted" data-id="element-220" data-mp="2x7pzr7g6axl0">ARS — Acceso inmediato de por vida</p>
              </div>
            </div>
          </div>
        </div>

        <motion.a href={CHECKOUT_URL} onClick={trackCheckoutClick} whileHover={{
        scale: 1.03
      }} whileTap={{
        scale: 0.98
      }} transition={{
        duration: 0.14,
        ease: [0.23, 1, 0.32, 1]
      }} className="cta-shimmer relative flex w-full justify-center overflow-hidden rounded-full bg-brand-blue px-6 py-5 text-center text-base font-bold text-brand-goldLight shadow-[0_12px_28px_rgba(8,32,60,.28)] ring-1 ring-brand-gold/50 md:text-xl" data-id="element-221" data-mp="2pnot7yyf8t3k">
          <span className="relative z-10" data-id="element-222" data-mp="21xuk9sh83ool">→ QUIERO MI KIT MAESTRO {PRICE_SHORT}</span>
        </motion.a>

        <div className="grid gap-3 rounded-2xl bg-brand-sageMist/70 p-4 text-center sm:grid-cols-4" data-id="element-223" data-mp="1x01civ09umm7">
          {['🛡️ Garantía 7 días', '📥 Descarga inmediata', '🔒 Pago seguro', '💳 Mercado Pago'].map(item => <span key={item} className="text-xs font-bold text-brand-greenMid" data-id="element-224" data-mp="1n0kcat3sh0xm">
              {item}
            </span>)}
        </div>
      </div>
    </Section>;
}
export function LaunchOffer() {
  return <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-225" data-mp="36ullybi343gg">
      <LaunchUrgency data-id="element-226" data-mp="3bv13lf9efx48" />
      <Pricing data-id="element-227" data-mp="3bt6s0rk0phct" />
    </div>;
}